<template>
  <v-footer dark padless>
    <v-card flat tile class="white--text text-center footer-card">
      <!-- Floating social icons (now fixed on screen) -->
      <div class="social-floating" aria-label="Social links">
        <v-tooltip v-for="s in socialLinks" :key="s.name" right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="social-btn"
              icon
              :href="s.href"
              target="_blank"
              rel="noopener noreferrer"
              :aria-label="`Open ${s.name} in new tab`"
            >
              <v-icon size="22">{{ s.icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ s.name }}</span>
        </v-tooltip>
      </div>
      <!-- /Floating social icons -->

      <v-card-text class="white--text pt-0">
        <v-row justify="space-around" id="container" ref="container">
          <v-col cols="12" sm="3" md="3" class="text-center pa-5">
            <div v-html="getFooterDetails.address1"></div>
            <v-divider></v-divider>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center pa-5">
            <div v-html="getFooterDetails.address2"></div>
            <v-divider></v-divider>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center pa-5">
            <div v-html="getFooterDetails.address3"></div>
            <v-divider></v-divider>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center pa-5">
            <div v-html="getFooterDetails.address4"></div>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="text-center">
            <img
              v-if="getFooterDetails.qrcode1"
              alt="QR code"
              :src="
                imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode1
              "
              height="250"
              contain
            />
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center">
            <img
              v-if="getFooterDetails.qrcode2"
              alt="QR code"
              :src="
                imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode2
              "
              height="250"
              contain
            />
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center">
            <img
              v-if="getFooterDetails.qrcode3"
              alt="QR code"
              :src="
                imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode3
              "
              height="250"
              contain
            />
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center">
            <img
              v-if="getFooterDetails.qrcode4"
              alt="QR code"
              :src="
                imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode4
              "
              height="250"
              contain
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="pa-0 white--text">
        <v-breadcrumbs
          :items="menus"
          divider="-"
          class="justify-center white--text breadcrum-color"
          color="white"
        ></v-breadcrumbs>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text text-center">
        {{ new Date().getFullYear() }} — <strong>Tatacrackers</strong> —
        <a @click="websiteOpen" class="font-weight-bold white--text"
          >Developed By Smartxpose Technologies</a
        >
      </v-card-text>
    </v-card>
  </v-footer>
</template>

// ...existing code...
<style>
.footer-card {
  width: 100%;
  /* no need for relative since icons are now fixed */
}
.breadcrum-color a {
  color: #fff !important;
}

/* Fixed floating social icons (always visible) */
.social-floating {
  position: fixed;
  left: 14px;
  bottom: max(16px, env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column; /* always vertical */
  gap: 10px;
  z-index: 2000;
}
.social-btn {
  width: 40px;
  height: 40px;
  background: #ff0164;
  border: 1px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(3px);
  transition: transform 0.15s ease, background 0.15s ease,
    border-color 0.15s ease;
}
.social-btn:hover {
  transform: translateY(-2px);
  background: rgba(25, 25, 25, 0.6);
  border-color: rgba(255, 255, 255, 0.46);
}
.social-btn .v-icon {
  color: #ffffff;
}

/* Mobile: keep vertical, just slightly smaller */
@media (max-width: 600px) {
  .social-floating {
    flex-direction: column; /* stay vertical */
    left: 12px;
    bottom: max(12px, env(safe-area-inset-bottom));
    gap: 8px;
  }
  .social-btn {
    width: 36px;
    height: 36px;
  }
}
</style>
// ...existing code...

<script>
import { mapActions, mapGetters } from "vuex";
import { VUE_WEB_BASEURL } from "../utils/api";

export default {
  name: "FooterCommon",
  data: () => ({
    imageUrl: "",
    menus: [
      { text: "FAQ", disabled: false, href: "/faq" },
      { text: "Privacy Policy", disabled: false, href: "/privacypolicy" },
      {
        text: "Terms And Condition",
        disabled: false,
        href: "/termsandcondition",
      },
    ],
    socialLinks: [
      {
        name: "Instagram",
        href: "https://www.instagram.com/kannancrackers01/",
        icon: "mdi-instagram",
      },
      {
        name: "YouTube",
        href: "https://www.youtube.com/@kannancrackers15",
        icon: "mdi-youtube",
      },
      {
        name: "X (Twitter)",
        href: "https://x.com/kannancracker01",
        icon: "mdi-twitter",
      },
      {
        name: "Threads",
        href: "https://www.threads.net/@kannancrackers01",
        icon: "mdi-at",
      }, // threads.net
    ],
  }),
  computed: {
    ...mapGetters(["getFooterDetails"]),
  },
  created() {
    this.fetchFooter();
    this.imageUrl = VUE_WEB_BASEURL;
  },
  methods: {
    ...mapActions(["fetchFooter"]),
    websiteOpen() {
      window.open("https://smartxpose.com/", "_blank");
    },
  },
};
</script>
